import React from "react";
import { useQueryPointOfSalesGroups } from "src/api/pointOfSalesGroups";
import { OrganizationStatus } from "src/types/organization";

interface SuperAdminSearchBarHook {
    elements;
    isPending: boolean;
}

export const useSuperAdminTopBar = (): SuperAdminSearchBarHook => {
    const [options, setOptions] = React.useState({
        elements: [],
        isPending: false,
    });

    const { data: pointsOfSalesGroups, isPending: pointsOfSalesGroupsPending } =
        useQueryPointOfSalesGroups();

    React.useEffect(() => {
        if (!pointsOfSalesGroupsPending) {
            // REMOVE DEMO ACCOUNTS FROM ADMIN ANALYZE VIEWS
            const filteredPointsOfSalesGroups = pointsOfSalesGroups.filter(
                (pointOfSalesGroup) =>
                    pointOfSalesGroup.organization.status !== OrganizationStatus.demo
            );
            setOptions({
                elements: [...filteredPointsOfSalesGroups],
                isPending: pointsOfSalesGroupsPending,
            });
        }
    }, [pointsOfSalesGroupsPending]);

    return options;
};
